/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerUpdateMutationRequest, FoldersControllerUpdateMutationResponse, FoldersControllerUpdatePathParams, FoldersControllerUpdate400, FoldersControllerUpdate401, FoldersControllerUpdate403, FoldersControllerUpdate404 } from "../../models/foldersController/FoldersControllerUpdate";

function getFoldersControllerUpdateUrl(id: FoldersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/folders/${id}` as const }  
  return res
}

/**
 * @summary Update a folder
 * {@link /api/v1/folders/:id}
 */
export async function foldersControllerUpdate(id: FoldersControllerUpdatePathParams["id"], data?: FoldersControllerUpdateMutationRequest, config: Partial<RequestConfig<FoldersControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FoldersControllerUpdateMutationResponse, ResponseErrorConfig<FoldersControllerUpdate400 | FoldersControllerUpdate401 | FoldersControllerUpdate403 | FoldersControllerUpdate404>, FoldersControllerUpdateMutationRequest>({ method : "PATCH", url : getFoldersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}